import promotionsEn from './promotions/en.json';
import promotionsZhHant from './promotions/zh-Hant.json';
import promotionsTh from './promotions/th.json';
import promotionsVi from './promotions/vi.json';

export default {
  en: promotionsEn,
  'zh-Hant': promotionsZhHant,
  vi: promotionsVi,
  th: promotionsTh,
};
